// Basics lifted from https://github.com/tj/react-click-outside/

import React from 'react';

interface Props extends React.HTMLProps<HTMLDivElement> {
  onClickOutside: (event: MouseEvent | React.MouseEvent) => void;
  children: React.ReactNode;
  enabled?: boolean;
  forwardedRef?: React.RefObject<HTMLDivElement>;
}

class ClickOutsideTrap extends React.Component<Props> {
  static defaultProps = {
    enabled: true,
  };

  ownRef = React.createRef<HTMLDivElement>();

  componentDidMount() {
    if (this.props.enabled) {
      document.addEventListener('mousedown', this.handleClickOutsideTrap, true);
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.enabled && this.props.enabled) {
      document.addEventListener('mousedown', this.handleClickOutsideTrap, true);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutsideTrap, true);
  }

  handleClickOutsideTrap = (event: MouseEvent | React.MouseEvent) => {
    if (this.props.enabled) {
      const target = event.target instanceof HTMLElement ? event.target : null;
      if (!target) {
        return;
      }

      const ignoredParent = target.closest('.ignore-react-onclickoutside');
      if (ignoredParent) {
        return;
      }

      const ref = this.props.forwardedRef ?? this.ownRef;
      const isOutside = !ref.current?.contains(target);
      if (isOutside) {
        this.props.onClickOutside(event);
      }
    }
  };

  render() {
    const { children, onClickOutside, enabled, forwardedRef, ...props } = this.props;
    return (
      <div {...props} ref={forwardedRef ?? this.ownRef}>
        {children}
      </div>
    );

    // How come this doesn't work on Dropdown within Dropdown?
    // Would be nice to skip the wrapper...

    // return React.cloneElement(children, {
    //   ...props,
    //   ref: (ref) => {
    //     this.container = ref;
    //   },
    // });
  }
}

export default ClickOutsideTrap;
